import { useQuery } from '@tanstack/react-query';
import { StockLevel } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const LOW_STOCK_ITEMS_QUERY_KEY = ['lowStockItems'];

export const useLowStockItems = () => {
  const isLoggedIn = useAppSelector((state: RootState) => state.user.isLoggedIn);
  const { organizationId } = useAppSelector(
    (state: RootState) => state.organization,
  );

  return useQuery<StockLevel[], Error>({
    queryKey: LOW_STOCK_ITEMS_QUERY_KEY,
    queryFn: async () => {
      const items = await warehouseService.getLowStockItems();
      return items || [];
    },
    // Don't run with a stale/expired session: an unauthenticated request would
    // trigger the global auto-logout in graphqlClient. Requires an active org.
    enabled: isLoggedIn && !!organizationId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

export default useLowStockItems;
